export const massiveUpload = {
    "loadMassiveOf": "Carga masiva de",
    "downloadBaseTemplate": "Descargar plantilla base",
    "configureTemplate": "Configure la plantilla base con la que desea realizar la carga masiva de",
    "downloadTemplate": "Descargar plantilla",
    "templateUser": "Plantilla usuario.xlsx",
    "templateStore": "Plantilla unidad.xlsx",
    "massiveImport": "Importación masiva de",
    "attachFile": "Adjunte el archivo CSV con la información y formato requerido",
    "importData": "Importar data",
    "verificationOf": "Comprobación de",
    "massiveUploadOf": "Carga masiva de",
    "resultsOf": "Resultados de",
    "pleaseWait": "Estamos haciendo la carga masiva, por favor espere. Este proceso puede tomar unos minutos",
    "resultsInfo": "A continuación se detallan los resultados de la carga masiva del archivo de",
    "sended": "enviado",
    "registersWithErrors": "Registros con error",
    "conflictResolution": "RESOLUCIÓN DE CONFLICTOS",
    "downloadUnloadedRecords": "Descargar registros no cargados",
    "reintent": "REINTENTAR"
  }